import {
  ApplicationConfig,
  provideZoneChangeDetection,
  APP_INITIALIZER,
  LOCALE_ID,
  inject,
  provideAppInitializer,
} from "@angular/core";
import { provideRouter, TitleStrategy } from "@angular/router";
import { provideClientHydration, withEventReplay } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { provideNgxMask } from "ngx-mask";
import { AuthInterceptorService } from "@core/http/interceptors/auth-interceptor.service";
import { BrowserstateInterceptor } from "@core/http/interceptors/browserstate.interceptor";
import { routes } from "./routes/app.routes";
import { SessionService } from "@core/state/session.service";
import { provideSpartanHlm } from '@spartan-ng/helm/utils';
import { ThemeService } from './core/theme/theme.service';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppTitleStrategy } from './core/title/app-title.strategy';

import { registerLocaleData, DatePipe, CurrencyPipe } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeZh from '@angular/common/locales/zh';

registerLocaleData(localePt, 'pt-BR');
registerLocaleData(localeEs, 'es-ES');
registerLocaleData(localeFr, 'fr-FR');
registerLocaleData(localeDe, 'de-DE');
registerLocaleData(localeZh, 'zh-CN');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideNgxMask(),
    provideSpartanHlm(),
    provideAppInitializer(() => inject(ThemeService).init()),
    DatePipe,
    CurrencyPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BrowserstateInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (session: SessionService) => () => session.init(),
      deps: [SessionService],
      multi: true,
    },

    { provide: LOCALE_ID, useValue: 'pt-BR' },

    provideTranslateService({
      lang: 'pt',
      fallbackLang: 'pt',
      loader: provideTranslateHttpLoader({
        prefix: 'assets/languages/',
        suffix: '.json',
      }),
    }),
  ],
};
